<template>
  <div class="createProrram">
    <div style="height: 100%">
      <div class="top">
        <van-icon size="22px" name="arrow-left" @click="back" />
        <div style="width: calc(100% - 40px); overflow-x: auto; white-space: nowrap; text-align: right">
          <span style="display: inline-block;width: 4px"></span>
          <van-button color="#FF5700" size="small" @click="emptyAllCanvns">{{$t('append_field.clear')}}</van-button>
          <span style="display: inline-block;width: 4px"></span>
          <van-button color="#006EFF" size="small" @click="restoreSize">{{$t('append_field.reduce')}}</van-button>
          <span style="display: inline-block;width: 4px"></span>
          <van-button color="#006EFF" size="small" @click="fullscreen">{{$t('append_field.fullscreen')}}</van-button>
          <span style="display: inline-block;width: 4px"></span>
          <van-button color="#006EFF" size="small" @click="submit(()=>{})">{{$t('append_field.save')}}</van-button>
          <span style="display: inline-block;width: 4px"></span>
          <van-button color="#006EFF" size="small"  @click="submit(getTerinalList)">{{$t('append_field.send')}}</van-button>
        </div>
      </div>
      <div id="canvas" class="canvas">
        <div id="image" :style="{
          backgroundImage: `url(${getbackUrl(backUrl)})`,
          backgroundColor:'#515151',
          backgroundSize: '100% 100%'
        }">
          <vdr :h="parseFloat(items.infoHeight) / zoom"
               :w="parseFloat(items.infoWidth) / zoom"
               v-on:dragging="onDrag"
               :y="parseFloat(items.infoY) / zoom"
               @activated="onActivated"
               @activate-tab="activateTab"
               :imgType="items.coType"
               :suffix="items.coType === 'doc'?getSuffix(items) : ''"
               :x="parseFloat(items.infoX) / zoom"
               :index="index"
               v-show="!dels.includes(items.id) && items.coType !== 'background'"
               :id="items.id"
               :ref="'draggable' + index"
               v-on:resizing="onResize" :parent="true"
               v-for="(items, index) in componentsList"
               :key="index">
            <div class="resizable-content" v-if="items.coType === 'img'">
              <img v-for="(item, subIndex) in items.mpList"
                   :key="subIndex"
                   :src="getImageUrl(item.url)"
                   class="img-content"
                   @load="onImageLoad(index, subIndex)"
                   @error="onImageError(index, subIndex)"
                   v-show="loadedImages[index] && loadedImages[index][subIndex]"/>
              <img v-for="(item, subIndex) in items.mpList"
                   :key="'placeholder-' + subIndex"
                   src="/static/images/placeholder.jpg"
                   class="img-content"
                   v-show="!loadedImages[index] || !loadedImages[index][subIndex]"/>
            </div>
            <div class="resizable-content" v-else-if="items.coType === 'subtitle'||items.coType === 'date'|| items.coType === 'weeks'||items.coType === 'time'" v-for="(item, subIndex) in items.txList"
                 :key="subIndex"
                 :style="{'backgroundColor': item.taBgColor, 'color': item.taColor, 'fontSize': item.taFontSize + 'px'}">
              <div class="text-content" :style="{'fontSize': getFontSize(item.taFontSize,zoom) }" >{{ item.taContent }}</div>
            </div>
            <div class="resizable-content" v-else-if="items.coType === 'video'">
              <img v-for="(item, subIndex) in items.mpList"
                   :key="subIndex"
                   :src="getImageUrl(item.viewUrl)"
                   style="width: 100%; height: 100%;"
                   @error="errImg(item)"
                   @load="onImageLoad(index, subIndex)"
                   v-show="loadedImages[index] && loadedImages[index][subIndex]"/>
              <img v-for="(item, subIndex) in items.mpList"
                   :key="'placeholder-' + subIndex"
                   src="/static/images/placeholder.jpg"
                   style="width: 100%; height: 100%;"
                   v-show="!loadedImages[index] || !loadedImages[index][subIndex]"/>
            </div>
            <div class="resizable-content" v-else-if="items.coType === 'streaming'" v-for="(item, subIndex) in items.txList"
                 :key="subIndex"
                 :style="{'backgroundColor': item.taBgColor, 'color': item.taColor, 'fontSize': item.taFontSize + 'px'}">
              <div class="text-content">
                <img src="/static/images/liumeiti.jpg" style="width: 100%; height: 100%;"
                     v-if="item.taContent !== ''"/>
              </div>
            </div>
            <div class="resizable-content" v-else-if="items.coType === 'webPage'" v-for="(item, subIndex) in items.txList"
                 :key="subIndex"
                 :style="{'backgroundColor': item.taBgColor, 'color': item.taColor, 'fontSize': item.taFontSize + 'px'}">
              <div class="text-content">
                <img src="/static/images/web.jpg" v-if="item.taContent !== ''"/>
              </div>
            </div>
            <div class="resizable-content" v-else-if="items.coType === 'mixture'">
              <img v-for="(item, subIndex) in items.mpList"
                   :key="subIndex"
                   :src="getMixtureUrl(item,items.coType)"
                   class="img-content"
                   @load="onImageLoad(index, subIndex)"
                   @error="onImageError(index, subIndex)"
                   v-show="loadedImages[index] && loadedImages[index][subIndex]"/>
              <img v-for="(item, subIndex) in items.mpList"
                   :key="'placeholder-' + subIndex"
                   src="/static/images/placeholder.jpg"
                   class="img-content"
                   v-show="!loadedImages[index] || !loadedImages[index][subIndex]"/>
            </div>

          </vdr>
        </div>
      </div>
      <div class="control-wrapper" >
        <!-- 节目信息的列表包括控件现实的信息   -->
        <div class="container">
          <div class="header">
            <div class="tabs-container">
              <div class="custom-van-tabs">
                <van-tabs v-model="activeTab" type="card" swipeable ref="tabs">
                  <van-tab :title="$t('append_field.program')">
                  </van-tab>
                  <van-tab :title="$t('append_field.control_addbackground')" v-if="showBg">
                    <template #title>
                      <span>{{ dynamicTitle('background') }}</span>
                      <van-icon name="/static/images/program/del.png" class="delete-icon" @click.stop="removeTab(1,'background')" />
                    </template>
                  </van-tab>
                  <van-tab v-for="(tab,index) in dynamicTabs" :key="tab.id">
                    <template #title>
                      <span>{{ dynamicTitle(tab.content) }}</span>
                      <van-icon name="/static/images/program/del.png" class="delete-icon" @click.stop="removeTab(index,tab.content)" />
                    </template>
                  </van-tab>
                </van-tabs>
              </div>
            </div>
            <div class="tabs-btn">
              <van-button  @click="addTab">
                <template #icon>
                  <img src="/static/images/program/add.png"
                       style="height: 40px;
                 display: flex;
                 align-items: center;
                 justify-content: center">
                </template>
              </van-button>
            </div>
          </div>
          <div class="playMode-content" >
            <div v-if="activeTab === 0">
              <div class="list">
                <van-row >
                  <span class="cell-title">{{$t('append_field.task_name')}}</span>
                  <div class="progremList">
                    <van-field v-model="taskName"  disabled />
                  </div>
                </van-row>
                <van-row >
                  <span class="cell-title">{{$t('append_field.playMode')}}</span>
                  <div class="progremList">
                    <van-radio-group v-model="taskPlayMode"  direction="horizontal">
                      <van-radio name="1">{{$t('append_field.replaceMode')}}</van-radio>
                      <van-radio name="2">{{$t('append_field.appendMode')}}</van-radio>
                      <van-radio name="3">{{$t('append_field.apotpatterns')}}</van-radio>
                    </van-radio-group>
                  </div>
                </van-row>
              </div>
              <div class="list" v-if="taskPlayMode!=='1'">
                <span class="cell-title">{{ $t('append_field.dateRange') }}</span>
                <van-row>
                  <van-field
                      v-model="startData"
                      is-link
                      input-align="right"
                      readonly
                      :label="$t('append_field.start_date')"
                      @click="showDatePicker('sData')"
                  />
                </van-row>
                <van-row>
                  <van-field
                      v-model="endData"
                      is-link
                      readonly
                      input-align="right"
                      :label="$t('append_field.end_date')"
                      @click="showDatePicker('eData')"
                  />
                </van-row>
                <span class="cell-title">{{ $t('append_field.timeRange') }}</span>
                <van-row>
                  <van-field
                      v-model="startTime"
                      is-link
                      input-align="right"
                      readonly
                      :label="$t('append_field.start_time')"
                      @click="showDatePicker('sTime')"
                  />
                </van-row>
                <van-row>
                  <van-field
                      v-model="endTime"
                      is-link
                      readonly
                      input-align="right"
                      :label="$t('append_field.end_time')"
                      @click="showDatePicker('eTime')"
                  />
                </van-row>
                <span class="cell-title">{{$t('append_field.taskPeriod') }}</span>
                <van-row class="weekliWrap">
                  <div class="weekli" @click="weekChoose('1')" :class="isActive1? 'active': ''">{{$t('append_field.mon')}}</div>
                  <div class="weekli" @click="weekChoose('2')" :class="isActive2? 'active': ''">{{$t('append_field.tue')}}</div>
                  <div class="weekli" @click="weekChoose('3')" :class="isActive3? 'active': ''">{{$t('append_field.wed')}}</div>
                  <div class="weekli" @click="weekChoose('4')" :class="isActive4? 'active': ''">{{$t('append_field.thu')}}</div>
                  <div class="weekli" @click="weekChoose('5')" :class="isActive5? 'active': ''">{{$t('append_field.fri')}}</div>
                  <div class="weekli" @click="weekChoose('6')" :class="isActive6? 'active': ''">{{$t('append_field.sat')}}</div>
                  <div class="weekli" @click="weekChoose('7')" :class="isActive7? 'active': ''">{{$t('append_field.sun')}}</div>
                </van-row>
              </div>
            </div>
            <div class="list" v-else >
              <imgsettings v-if="imgsetting && isMpListValid(controlIndex)"
                           :lists="componentsList[controlIndex].mpList"
                           @ondele="ondele"
                           />
              <videosettings v-if="videosetting && isMpListValid(controlIndex)"
                             :lists="componentsList[controlIndex].mpList"
                             @ondele="ondele"
                             />
              <audioSettings v-if="audioSetting && isMpListValid(controlIndex)"
                             :lists="componentsList[controlIndex].mpList"
                             @ondele="ondele"
              />
              <docSettings v-if="docSetting && isMpListValid(controlIndex)"  :lists="componentsList[controlIndex].mpList"
                           @ondele="ondele"
                           />
              <mixtureSettings v-if="mixtureSettings && isMpListValid(controlIndex)"
                               :lists="componentsList[controlIndex].mpList"
                               @ondele="ondele"
                               />
              <fontsettings v-if="subtitlesetting&& isTxListValid(controlIndex)"
                            @setText="getText"
                            @close="close"
                            :text="componentsList[controlIndex]"
                            :key="`${controlIndex}`"
                          />
              <streamings v-if="streaming&& isTxListValid(controlIndex)"
                          @setText="getText"
                          @close="close"
                          :text="componentsList[controlIndex]"
                          :key="`${controlIndex}`"
                         />
              <websettings v-if="websetting&& isTxListValid(controlIndex) "
                           @setText="getText"
                           :key="`${controlIndex}`"
                           :text="componentsList[controlIndex]"
                           @close="close"
                           />
              <backgroundsetting  v-if="backgroundList" :pageBg="bgImg"  @ondele="clearBg"  />
              <!--    多写一层方便直接打开选择素材          -->
              <dateSettings v-if="dateSetting && isTxListValid(controlIndex)" :text="componentsList[controlIndex]" @ondele="ondele" />
           </div>
          </div>
        </div>
        <!--  时间和日期的弹窗  -->
      </div>
    </div>
    <van-overlay :show="show1">
      <div style="height: 100%;display: flex;justify-content: center;align-items: center">
        <van-loading  size="40px" vertical >{{$t('append_field.loadinga')}}</van-loading>
      </div>
    </van-overlay>
    <van-popup v-model="isShowStartData" position="bottom">
      <van-datetime-picker
          type="date"
          :title="$t('append_field.selectStartDate')"
          :min-date="minDate"
          :max-date="maxDate"
          @confirm="startDataChoose"
          @cancel="isShowStartData = false"
      />
    </van-popup>
    <van-popup v-model="isShowEndData" position="bottom">
      <van-datetime-picker
          type="date"
          :title="$t('append_field.selectEndDate')"
          :min-date="minDate"
          :max-date="maxDate"
          @confirm="endDataChoose"
          @cancel="isShowEndData = false"
      />
    </van-popup>
    <van-popup v-model="isShowStartTime" position="bottom">
      <van-datetime-picker
          type="time"
          :title="$t('append_field.selectStartTime')"
          @confirm="startTimeChoose"
          @cancel="isShowStartTime = false"
      />
    </van-popup>
    <van-popup v-model="isShowEndTime" position="bottom">
      <van-datetime-picker
          type="time"
          :title="$t('append_field.selectEndTime')"
          @confirm="endTimeChoose"
          @cancel="isShowEndTime = false"
      />
    </van-popup>
    <!-- 选择控件的遮罩层   -->
    <van-overlay v-show="showControl" @click="showControl = false"  class="overlay">
      <div class="wrapper">
        <van-icon class="icon-container" v-for="(button) in buttonList" :key="button.id" @click="addTabWithContent( button.content)">
          <img :src="button.icon" alt="icon" style="height: 50px" />
          <span class="overlay-text">{{ dynamicTitle(button.content) }}</span>
        </van-icon>
      </div>
    </van-overlay>
    <!--  设备列表弹窗  -->
    <DeviceSelectDialog
                class="device-list"
      v-model="dialogDeviceList"
                :title="$t('append_field.deviceList')"
                :beforeClose="vBeforeClose"
      :pageSize="10"
      :fetchGroups="fetchDeviceGroups"
      :fetchDevices="fetchDeviceList"
      :initialOnlineState="state"
      :initialClientName="clientName"
      :initialGroupParentId="groupParentId"
      @confirm="onDeviceDialogConfirm"
      @confirm-empty="onDeviceDialogConfirmEmpty"
                @cancel="closeDeviceList"
          />
  </div>
</template>

<script>
import vdr from '../components/vue-draggable-resizable'
import qs from 'qs'

import imgsettings from '../components/imgsettings'
import fontsettings from '../components/fontsettings'
import videosettings from '../components/videosettings'
import websettings from '../components/websettings'
import {mapActions, mapState} from 'vuex'
import {Dialog, Toast} from 'vant'
import backgroundsetting from "@/components/backgroundsetting.vue";
import streamings from "@/components/streamings.vue";
import {vBeforeClose} from "@/utils/tool";
import mixtureSettings from "@/components/mixtureSettings.vue";
import dateSettings from "@/components/dateSettings.vue";
import docSettings from "@/components/docSettings.vue";
import audioSettings from "@/components/audioSettings.vue";
import {getFileSuffix} from "../utils";
import DeviceSelectDialog from '@/components/DeviceSelectDialog.vue'

export default {
  name: 'createProrram',
  inject: ['reload'],
  data() {
    return {
      pmId: this.$route.query.id,
      mainResolutionW: 0,
      mainResolutionH: 0,
      zoom: 1,
      imgsetting: false,
      videosetting: false,
      subtitlesetting: false,
      websetting: false,
      hdmin: false,
      streaming:false,
      bgImg:'',
      backgroundList:false,
      show1: false,
      disabled: true,
      type: 'add',
      prmgremMsg: [],
      width: 0,
      height: 0,
      loadedImages: {}, // 存储图片加载状态
      minDate:new Date(2024,0,1),
      maxDate:new Date(2100,10,5),
      activeTab: 0,
      dynamicTabs:[],
      taskPlayMode:'1',
      taskId:'',
      taskName:'',
      startData: this.$t('append_field.selectStartDates'),
      endData: this.$t('append_field.selectEndDates'),
      startTime: '00:00:00',
      endTime: '23:59:00',
      isActive1: true,
      isActive2: true,
      isActive3: true,
      isActive4: true,
      isActive5: true,
      isActive6: true,
      isActive7: true,
      weekArr: [true, true, true, true, true, true, true],
      showData:false,
      isShowStartData: false,
      isShowEndData: false,
      isShowStartTime: false,
      isShowEndTime: false,
      showControl:false,
      buttonList: [
        { id: 1, content: 'img', icon: '/static/images/program/img.png' },
        { id: 2, content: 'video', icon: '/static/images/program/video.png' },
        { id: 3, content: 'audio', icon: '/static/images/program/audio.png' },
        { id: 4, content: 'mixture', icon: '/static/images/program/mixture.png' },
        { id: 5, content: 'doc', icon: '/static/images/program/doc.png' },
        { id: 6, content: 'date', icon: '/static/images/program/date.png' },
        { id: 7, content: 'weeks', icon: '/static/images/program/weeks.png' },
        { id: 8, content: 'time', icon: '/static/images/program/time.png' },
        { id: 9, content: 'subtitle', icon: '/static/images/program/subtitle.png' },
        { id: 10, content: 'streaming', icon: '/static/images/program/streaming.png' },
        { id: 11, content: 'webPage', icon: '/static/images/program/webPage.png' },
        { id: 12, content: 'background', icon: '/static/images/program/addbackground.png' },
        { id: 13, content: 'hdmin', icon: '/static/images/program/hdmin.png' }
        // 可以继续添加更多按钮
      ],
      showBg:false,//背景的页签显示
      dialogDeviceList:false, //
      terminalMenuItems: [],
      activeNames: '',
      terminalSelect: [],
      data_m: [],
      index: 0,
      checkedItems:[],
      selectedIndex: 0,
      newId:0,
      dialogShow:false,
      clientName:'',
      mixtureSettings:false,
      isMixtureList:false,
      docSetting:false,
      dateSetting:false,
      audioSetting:false,
      state: '0',
      isCheckAll:false,
      isIndeterminate:false,
      allData: [], // 所有设备的数据
      groupParentId:1
    }
  },
  // 生命周期钩子
  mounted() {

    // 初始化画布宽度和高度
    this.width = document.getElementById('canvas').offsetWidth
    this.$nextTick(() => {
      document.getElementById('canvas').style.height = `${this.width}px`
    })


  },
  created() {
    // 初始化节目信息 和pc端不同，这里获取的是任务的信息
    let taskDetailData=this.$route.query.taskDetailData

    const cache = sessionStorage.getItem('taskDetailData')
    taskDetailData = JSON.parse(cache)

    // 设置类型
    if (this.$route.query.type) {
      this.type = this.$route.query.type
    }
    const hasTaskDetail = Array.isArray(taskDetailData) && taskDetailData.length > 0

    if(this.type==='edit' && hasTaskDetail){
      this.taskId=taskDetailData[0].id
      this.taskName=taskDetailData[0].etName
      this.taskPlayMode=taskDetailData[0].etLevel?taskDetailData[0].etLevel: 1
      let now = new Date()
      let nextYear = new Date(new Date().setFullYear(now.getFullYear() + 1))
      this.startData =taskDetailData[0].etStartDate?taskDetailData[0].etStartDate: this.formatter(now)
      this.endData = taskDetailData[0].etEndDate?taskDetailData[0].etEndDate: this.formatter(nextYear)
      this.startTime= taskDetailData[0].etStartTime?taskDetailData[0].etStartTime:'00:00:00'
      this.endTime= taskDetailData[0].etEndTime?taskDetailData[0].etEndTime:'23:59:00'
      this.isActive1 = taskDetailData[0].etMon !== 'false'
      this.isActive2 = taskDetailData[0].etTue !== 'false'
      this.isActive3 = taskDetailData[0].etWed !== 'false'
      this.isActive4 = taskDetailData[0].etThur !== 'false'
      this.isActive5 = taskDetailData[0].etFri !== 'false'
      this.isActive6 = taskDetailData[0].etSat !== 'false'
      this.isActive7 = taskDetailData[0].etSun !== 'false'
    }else {
      this.taskId=this.$route.query.taskId
      this.taskName=this.$route.query.taskName
      let now = new Date()
      let nextYear = new Date(new Date().setFullYear(now.getFullYear() + 1))
      this.startData = this.formatter(now)
      this.endData =  this.formatter(nextYear)
    }

    this.selectPhoneProgramMould()
  },
  methods: {
    vBeforeClose,
    ...mapActions(['addControl', 'addSubtitle', 'emptyCanvns', 'addBackground']),
    fetchDeviceGroups() {
      return this.$ajax.post('/etv/selectDeviceTree.json').then(res => {
        if (res.data.code === 0) {
          return res.data.data[0].children
        }
        Toast(res.data.msg)
        return []
      })
    },

    fetchDeviceList({ onlineState, clientName, groupParentId }) {
      return this.$ajax.post('/etv/searchMobileDeviceTree.json', qs.stringify({
        onlineState,
        clientName,
        groupParentId,
      })).then(res => {
        if (res.data.code === 0) {
          return res.data.data
        }
        Toast(res.data.msg)
        return []
      })
    },

    onDeviceDialogConfirmEmpty() {
      Toast(this.$t('append_field.selectDevice'))
    },

    onDeviceDialogConfirm(payload) {
      this.terminalSelect = payload.terminalSelect
      this.state = payload.onlineState
      this.clientName = payload.clientName
      this.groupParentId = payload.groupParentId
      this.confirmSend()
    },
    selectPhoneProgramMould(){
    // 请求数据 画布中的控件
    this.$ajax.post('/etv/selectPhoneProgramMould.json', qs.stringify({
      pmId: this.pmId,
    })).then(res => {
        if (res.data.code === 0) {
        document.title = this.$t('append_field.create_program')
        const resolution = res.data.data.pmResolution?res.data.data.pmResolution:this.pmResolution(res.data.data.pmFixedScreen)
        this.mainResolutionW = parseInt(resolution.split('*')[0])
        this.mainResolutionH = parseInt(resolution.split('*')[1])
        this.getZoom()
        this.$store.state.componentsList = res.data.data.sceneList[0].componentsList
        const isHttpUrl = res.data.data.sceneList[0].scBackImg.startsWith("http")
        if (isHttpUrl) {
          this.$store.state.backUrl = res.data.data.sceneList[0].scBackImg
        }else {
          this.$store.state.backUrl = this.upFileUrl + res.data.data.sceneList[0].scBackImg
        }

        if(res.data.data.sceneList[0].scBackImg!==''){
          this.showBg=true
        }
        this.$store.state.sceneList = res.data.data.sceneList[0]
        this.componentsList.map(res => {
          res.infoX = res.coLeftPosition
          res.infoY = res.coRightPosition
          res.infoWidth = res.coWidth
          res.infoHeight = res.coHeight
        })
        this.prmgremMsg = [res.data.data]
        this.dynamicTabs = res.data.data.sceneList[0].componentsList.map((tab) => ({
          id: tab.id,
          title: this.dynamicTitle(tab.coType),
          content: tab.coType
        }));
        this.newId=this.dynamicTabs.length
        this.$nextTick(() => {
          this.activeTab = -2; // 默认激活第一个标签
        });
      }
    })
  },
    pmResolution(type){
      if (type === 1) {
        return '1920*1080'
      } else if (type === 2) {
        return '1080*1920'
      }
    },
    isMpListValid(index) {
      // 检查 mpList 是否存在且为数组
      return Array.isArray(this.componentsList[index]?.mpList)
    },
    isTxListValid(index) {
      // 检查 mpList 是否存在且为数组
      return Array.isArray(this.componentsList[index]?.txList)
    },
    /*
    * 添加新的控件
    * */
    addTabWithContent(content) {
      this.resetControlSettings()
      if (content === 'background') {
        this.showBg = true
        this.backgroundList=true
        this.$nextTick(() => {
          this.activeTab = 1 // 切换到新添加的标签
        })
      } else {

        this.newId++
        let id=function f() {
          const arr = [1, 2, 3, 4, 5, 6, 7, 8, 9, 0, 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't']
          let str = ''
          for (let i = 0; i < 12; i++) {
            str += arr[Math.floor(Math.random() * arr.length)]
          }
          return str
        }()
        this.dynamicTabs.push({id: id,content: content })
        this.onActivated(this.newId, content)
        this.addControl(content)
        this.$nextTick(() => {
          this.activeTab =this.newId + (this.showBg ? 1 : 0) // 切换到新添加的标签
          this.scrollToLastTab()  //直接滚动到添加控件的位置
        })

      }


    },
    /*
    * 点击控件的时候，切换到对应的标签页
    * */
    onTabChange(newIndex) {
      const fixedTabsCount = this.showBg ? 2 : 1 // 固定标签的数量
      this.resetControlSettings()
      if (this.showBg && newIndex === 1) {
        this.backgroundList = true
      } else {
        const dynamicTabIndex = newIndex - fixedTabsCount
        if (dynamicTabIndex >= 0 && dynamicTabIndex < this.componentsList.length) {
          const control = this.componentsList[dynamicTabIndex]
          this.onActivated(dynamicTabIndex, control.coType)
          this.$root.$emit('activate-control', dynamicTabIndex)
        }
      }

    },
    removeTab(index, type) {
      const fixedTabsCount = this.showBg ? 2 : 1;
      let newActiveTab = this.activeTab;
      Dialog.confirm({
        title: this.$t('append_field.del_title'),
        message: this.$t('append_field.del_message'),
      })
          .then(() => {
            if (type === 'background') {
              this.clearBg()
              this.showBg = false
              newActiveTab = 0
            } else {
              this.componentsList.splice(index, 1)
              this.dynamicTabs.splice(index, 1)
              if (this.activeTab === index + fixedTabsCount) {
                newActiveTab -= 1
              } else if (this.activeTab > index + fixedTabsCount) {
                newActiveTab = 0
              }
              this.newId--
            }
            this.activeTab = newActiveTab
          })

    },
    activateTab(newIndex) {
      this.activeTab = newIndex + (this.showBg ? 2 : 1)
    },
    scrollToLastTab() {
      this.$nextTick(() => {
        const tabsElement = this.$refs.tabs.$el;
        const lastTabElement = tabsElement.querySelector('.van-tab:last-child')
        if (lastTabElement) {
          lastTabElement.scrollIntoView({ behavior: 'smooth' })
        }
      })
    },
    onActivated(index, type) {
      this.$store.state.controlIndex = index
      switch (type) {
        case 'img':
          this.imgsetting = true
          break
        case 'video':
          this.videosetting = true
          break
        case 'subtitle':
          this.subtitlesetting = true
          break
        case 'hdmin':
          this.hdmin = true
          break
        case 'webPage':
          this.websetting = true
          break
        case 'streaming':
          this.streaming = true
          break
        case 'mixture':
          this.mixtureSettings = true
          break
        case 'doc':
          this.docSetting = true
          break
        case 'audio':
          this.audioSetting = true
          break
        default:
          this.dateSetting = true
          break
      }
    },
    // 页面和控件布局相关方法
    getZoom() {
      if (this.mainResolutionW / this.mainResolutionH > 1) {
        this.zoom = this.mainResolutionW / this.width;
        document.getElementById('image').style.height = this.mainResolutionH / this.zoom +  'px';
      } else {
        document.getElementById('image').style.height = '100%';
        this.zoom = this.mainResolutionH / this.width
        document.getElementById('image').style.width = this.mainResolutionW / this.zoom + 'px';
      }

    },
    onResize(x, y, width, height) {
      this.componentsList[this.controlIndex].coHeight = height * this.zoom;
      this.componentsList[this.controlIndex].coWidth = width * this.zoom;
      this.componentsList[this.controlIndex].coLeftPosition = x * this.zoom;
      this.componentsList[this.controlIndex].coRightPosition = y * this.zoom;
    },
    onDrag(x, y) {
      this.componentsList[this.controlIndex].coLeftPosition = x * this.zoom;
      this.componentsList[this.controlIndex].coRightPosition = y * this.zoom;
    },
    // 背景相关方法
    clearBg() {
      this.bgImg = ''
      this.$store.state.backUrl=''
      this.addBackground({})
    },
/*    setBackImage(data) {
      this.backgroundList = true
      this.addBackground(data)
      const isHttpUrl = data.url.startsWith("http")
      if (isHttpUrl) {
        this.bgImg =  data.url
      }else {
        this.bgImg = this.upFileUrl + data.url
      }

    },*/
    // 其他控件相关方法
    ondele(index) {
      this.componentsList[this.controlIndex].mpList.splice(index, 1)
    },
    close() {
      this.websetting = false
      this.subtitlesetting = false
    },
    getText(data) {
      this.addSubtitle({
        data,
      })
    },
    // 路由和导航相关方法
    gotoa(url, query) {
      this.$router.push({
        path: url,
        query,
      })
    },
    back() {
      this.dialogShow=true
      Dialog.confirm({
        title: this.$t('append_field.exit'),
        message: this.$t('append_field.confirm_leave_page'),
      }).then(() => {
        this.$router.push({path: '/programs', query: {itemName: 'a'}})

      })
    },
    emptyAllCanvns(){
      Dialog.confirm({
        title: this.$t('append_field.del_title'),
        message: this.$t('append_field.del_message'),
        }).then(() => {
            //清空画布，重置参数
            this.emptyCanvns()
            this.clearBg()
            this.dynamicTabs=[]
            this.showBg = false
            this.newId=0

       })

    },
    // 数据提交相关方法
    submit(callback) {
      this.state='0'
      this.clientName=''
      this.updateEquipmentTask()
          .then(() => {
            let obj = {
              backImg: this.sceneList.scBackImg || "",
              backImgId: this.sceneList.scBackImgId || "",
              backImgSize: this.sceneList.scBackimgSize || "",
              pmId: this.sceneList.scPmId,
              scTime: this.sceneList.scTime,
              sort: this.sceneList.scSort,
              scId: this.sceneList.id,
              scName: this.sceneList.scName,
              type: this.type,
              html: 'hello word',
              isSaveBtn: true,
            };
            let compents = []
            let data = this.componentsList.filter(res => {
              return !this.dels.includes(res.id)
            });
            for (let i = 0; i < data.length; i++) {
              let materials = []
              if (['subtitle', 'webPage', 'streaming', 'hdmin'].includes(data[i].coType)) {
                data[i].txList.forEach(res => {
                  if (res.taContent === '' && data[i].coType!=='hdmin') {
                    Toast(this.$t('append_field.add_content_to_control'));
                    return
                  }
                  materials.push({
                    'color': res.taColor, // 颜色
                    'content': res.taContent, // 内容
                    'fontSize': res.taFontSize, // 长度
                    'move': res.taMove, // 滚动方向
                    'no': 1, // 序号
                    'alignment': res.taAlignment, // 对齐方式
                    'bgColor': res.taBgColor, // 字幕背景色
                    'moveSpeed': res.taMoveSpeed, // 字幕滚动速度
                    'difference': 2, // 属性控件 字幕、天气、日期等控件
                    'address': '', // 地址
                    'countDown': '`',
                    "bgImage": '',
                  })
                })
              } else if(['img', 'video', 'mixture', 'doc','audio'].includes(data[i].coType)){
                data[i].mpList.forEach(res => {
                  materials.push({
                    mtId: res.mid,
                    playParam: res.playParam,
                    difference: '1',
                    cartoon: res.cartoon,
                    vol: res.volume,
                    suffix:res.suffix
                  })
                })
              }else if(['date', 'weeks', 'time'].includes(data[i].coType)){
                data[i].txList.forEach(res => {
                  materials.push({
                    'color': res.taColor, // 颜色
                    'content': res.taContent, // 内容
                    'fontSize': res.taFontSize, // 长度
                    'move': res.taMove, // 滚动方向
                    'no': 1, // 序号
                    'alignment': res.taAlignment, // 对齐方式
                    'bgColor': res.taBgColor, // 字幕背景色
                    'moveSpeed': res.taMoveSpeed, // 字幕滚动速度
                    'difference': 2, // 属性控件 字幕、天气、日期等控件
                    'address': '', // 地址
                    'countDown': '`',
                    "bgImage": '',
                  })
                })
              }

              if (materials.length === 0 && data[i].coType !== 'hdmin') {
                Toast(this.$t('append_field.add_content_to_control'))
                return
              }
              compents.push({
                'type': data[i].coType,
                'leftPosition': parseFloat(data[i].coLeftPosition),
                'rightPosition': parseFloat(data[i].coRightPosition),
                'width': data[i].coWidth,
                'height': data[i].coHeight,
                'actionType': '',
                'linkAction': '',
                'screenProtectTime': '10',
                'materials': materials,
              })
            }

            if (compents.length === 0) {
              Toast(this.$t('append_field.add_control'))
              return
            }
            obj.compents = compents
            this.show1 = true
            this.$ajax({
              method: 'post',
              url: '/etv/insertPhoneSceneInfo.json',
              data: obj,
              headers: {
                'content-type': 'application/json',
              },
            }).then(res => {
              if (res.data.code === 0) {
                Toast(this.$t('append_field.save_success'))
                this.show1 = false
                this.$store.state.sceneList.id = res.data.data

                callback && callback(this.getTerinalList)

              } else {
                Toast(res.data.msg)
                this.show1 = false
              }
            })
          })
          .catch(error => {
            Toast(error.message )
          })
    },

    updateEquipmentTask() {
      return new Promise((resolve, reject) => {
        // 创建开始和结束的 Date 对象
        const startDate = new Date(`${this.startData}T${this.startTime}`)
        const endDate = new Date(`${this.endData}T${this.endTime}`)

        // 检查结束日期是否早于开始日期
        if (endDate < startDate) {
          Toast(this.$t('append_field.end_date_earlier_than_start_date'))
          reject(new Error(this.$t('append_field.end_date_earlier_than_start_date')))
          return; // 终止函数执行
        }
        this.$ajax.post('/etv/updateEquipmentTask.json', qs.stringify({
          etName: this.taskName,
          id: this.taskId,
          etStartDate: this.startData,
          etStartTime: this.startTime,
          etEndDate: this.endData,
          etEndTime: this.endTime,
          etState: '1',
          playMode: this.taskPlayMode,
          etPlayMode: this.taskPlayMode,
          etLevel: this.taskPlayMode,
          etEcId: '1',
          etMon: this.isActive1,
          etTue: this.isActive2,
          etWed: this.isActive3,
          etThur: this.isActive4,
          etFri: this.isActive5,
          etSat: this.isActive6,
          etSun: this.isActive7,
        })).then(res => {
          if (res.data.code === 0) {
            Toast(res.data.msg)
            resolve()
          } else {
            reject(new Error(res.data.msg))
          }
        })
      })
    },
    // 全屏相关方法
    fullscreen() {
      let sc = 'draggable' + this.controlIndex
      this.$refs[sc][0].fillParent()
    },
    restoreSize(){
      let sc = 'draggable' + this.controlIndex
      this.$refs[sc][0].restoreSize()

    },
    // 图片相关方法
    getImageUrl(url) {

      let isHttpUrl= url.startsWith("http")

      if(!url){
        return '/static/images/icon_loader_failed_braseas.png'
      }

      if (isHttpUrl) {
        // 如果是 HTTP URL 且不是 MP4 文件，直接返回 URL
        return url
        }
      // 如果不是 HTTP URL，拼接基础 URL 并返回
      return this.upFileUrl + url
    },
    onImageLoad(index, subIndex) {
      if (!this.loadedImages[index]) {
        this.$set(this.loadedImages, index, {})
      }
      this.$set(this.loadedImages[index], subIndex, true)
    },
    onImageError(index, subIndex) {
      if (!this.loadedImages[index]) {
        this.$set(this.loadedImages, index, {})
      }
      this.$set(this.loadedImages[index], subIndex, false)
    },
    errImg(obj) {
      obj.viewUrl = "static/images/icon_loader_failed.png"
      obj.url = "static/images/icon_loader_failed.png"
    },
    //混播控件
    getMixtureUrl(item){
      let url
      let isHttpUrl
      if(item.type==='video'){
          isHttpUrl =  item.viewUrl.startsWith("http")
          if(isHttpUrl){
            url = item.viewUrl
          }else {
            url= this.upFileUrl + item.viewUrl
          }
      }else {
        isHttpUrl =  item.url.startsWith("http")
        if(isHttpUrl){
          url = item.url
        }else {
          url= this.upFileUrl + item.url
        }
      }
      // 添加时间戳
      return `${url}?t=${new Date().getTime()}`
    },
    addTab() {
      this.showControl=true
    },
    // 日期和时间相关方法
    formatter(date) {
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`
    },
    showDatePicker(type) {
      if (type === 'sData') {
        this.isShowStartData = true
      } else if (type === 'eData') {
        this.isShowEndData = true
      } else if (type === 'sTime') {
        this.isShowStartTime = true
      } else if (type === 'eTime') {
        this.isShowEndTime = true
      }
    },
    startDataChoose(res) {
      this.startData = this.formatter(res)
      this.isShowStartData = false
    },
    endDataChoose(res) {
      this.endData = this.formatter(res)
      this.isShowEndData = false
    },
    startTimeChoose(res) {
      this.startTime = res + ':00'
      this.isShowStartTime = false
    },
    endTimeChoose(res) {
      this.endTime = res + ':00'
      this.isShowEndTime = false
    },

    // 周期选择相关方法
    weekChoose(res) {
      const weekMap = {
        '1': 'isActive1',
        '2': 'isActive2',
        '3': 'isActive3',
        '4': 'isActive4',
        '5': 'isActive5',
        '6': 'isActive6',
        '7': 'isActive7'
      };
      const activeKey = weekMap[res]
      if (activeKey) {
        this[activeKey] = !this[activeKey]
        this.weekArr[res - 1] = this[activeKey]
      }
    },

    // 动态标签页标题相关方法
    dynamicTitle(content) {
      const titleMap = {
        'img': this.$t('append_field.image'),
        'video': this.$t('append_field.control_video'),
        'audio': this.$t('append_field.audio'),
        'mixture': this.$t('append_field.mixture'),
        'doc': this.$t('append_field.document'),
        'date': this.$t('append_field.date'),
        'weeks': this.$t('append_field.weeks'),
        'time': this.$t('append_field.time'),
        'webPage': this.$t('append_field.webPage'),
        'streaming': this.$t('append_field.media'),
        'subtitle': this.$t('append_field.subtitle'),
        'background': this.$t('append_field.control_addbackground'),
        'hdmin': 'HDMI-IN',

      };
      return titleMap[content] || content
    },

    // 重置控件设置
    resetControlSettings() {
      this.imgsetting = false
      this.videosetting = false
      this.subtitlesetting = false
      this.websetting = false
      this.hdmin = false
      this.streaming=false //流媒体
      this.backgroundList = false
      this.mixtureSettings=false
      this.docSetting=false
      this.dateSetting=false
      this.audioSetting = false
    },

    //设备列表
    confirmSend() {
      if (this.terminalSelect.length == 0) {
        Toast(this.$t('append_field.selectDevice'))
        return
      }
      let _this = this
      let postData = {
        ceEtId: _this.taskId,
        clientIdList: '',
      }
      let terminalSelectedArr = _this.terminalSelect
      let noArr = [], idArr = []
      for (var i = 0; i < terminalSelectedArr.length; i++) {
        idArr.push(terminalSelectedArr[i].split('-')[1])
        noArr.push(terminalSelectedArr[i].split('-')[0])
      }

      postData.clientIdList = idArr
      this.$ajax.post('/etv/insertClientEqTask.json', postData).then(res => {
        if (res.data.code == 0) {
          Toast(this.$t('append_field.sendTaskSuccess'))
          _this.isVisible4 = false
          _this.terminalSelect = []
          _this.activeNames = ['1']
          _this.taskId = ''
          _this.$router.push({path: '/programs', query: {itemName: 'c'}})
        } else {
          Toast(res.data.msg)
        }


      })
    },
    getTerinalList() {
      this.dialogDeviceList = true
      this.state = '0'
      this.clientName = ''
    },
    loadDeviceList(index) {
      this.isCheckAll=false
      this.terminalSelect=[]
      this.activeNames = index;
      this.index = 0;
      this.data_m = this.terminalMenuItems[index].children.slice(0, 10); //加载前十条数据
      this.allData = this.terminalMenuItems[index].children // 所有数据
      this.selectedIndex = index


    },
    truncatedName(fullName) {
      // 截断名称并确保括号内容完整显示
      const namePart = fullName.split(' (')[0]
      const infoPart = fullName.includes('(') ? `${fullName.slice(fullName.indexOf('('))}` : ''
      if (namePart.length  <= 4) {
        return fullName
      } else {
        return `${namePart.substring(0, 4)}...${infoPart}`
      }
    },
    //滚动事件
    handleScroll2() {
      const scrollContainer = this.$refs.scrollContainer
      if (!scrollContainer) return;

      const scrollHeight = scrollContainer.scrollHeight;
      const clientHeight = scrollContainer.clientHeight;
      const scrollTop = scrollContainer.scrollTop;
      const scrollOffset = 40; // Adjust this value as needed

      if (clientHeight + scrollTop + scrollOffset >= scrollHeight) {
        const children = this.terminalMenuItems[this.activeNames].children;
        if (children.slice(this.index * 10, this.index * 10 + 10).length < 10) {
          return;
        }
        this.index++;
        this.data_m = [...new Set([...this.data_m, ...children.slice(this.index * 10, this.index * 10 + 10)])];
      }
    },
    // 复选框组状态变化时调用
    checkedResultChange() {
      this.updateIndeterminateState()
    },
    // 切换复选框状态
    toggleCheckbox(item) {
      const name = `${item.clNo}-${item.clId}`
      const index = this.terminalSelect.indexOf(name)
      if (index > -1) {
        this.terminalSelect.splice(index, 1)
      } else {
        this.terminalSelect.push(name)
      }
      this.updateIndeterminateState()
    },
    // 全选/取消全选
    checkAllChange() {
      if (this.isCheckAll) {
        this.terminalSelect = this.allData.map(item => `${item.clNo}-${item.clId}`)
      } else {
        this.terminalSelect = []
      }
      this.updateIndeterminateState()
    },
    // 更新不确定状态
    updateIndeterminateState() {
      //需要显示设备列表时才执行
      if(this.allData.length===0) return
      const totalItems = this.allData.length
      const checkedItems = this.terminalSelect.length
      this.isCheckAll = checkedItems === totalItems
      this.isIndeterminate = checkedItems > 0 && checkedItems < totalItems
    },

    isChecked(item) {
      const name = `${item.clNo}-${item.clId}`
      return this.terminalSelect.includes(name)
    },
    closeDeviceList(){
      this.terminalSelect = [] // 清空选择
    },
    onSearch() {
      this.getTerinalList(this.state,this.clientName)
      this.show = false
    },
    getSuffix(item){
      //判断doc控件的类型
      if(item && item.mpList.length!==0 ){

        const suffix = getFileSuffix(item.mpList[0].name)
        const fileType = '.' + suffix.toLowerCase()
        return fileType
      }else {
        return ''
      }
    },
    getbackUrl(url){
      if (!url) {
        return url
      }
      const isHttpUrl =  url.startsWith("http")
      if (isHttpUrl) {
        return  url
      }else {
        return this.upFileUrl + url
      }
    },
    getFontSize(item,zoom){
      return item/zoom + 'px'
    }


  },
  computed: {
    ...mapState({
      controlIndex: state => state.controlIndex,
      componentsList: state => state.componentsList,
      sceneList: state => state.sceneList,
      backUrl: state => state.backUrl,
      dels: state => state.dels,
    }),
  },
  components: {
    streamings,
    vdr,
    imgsettings,
    videosettings,
    fontsettings,
    websettings,
    backgroundsetting,
    mixtureSettings,
    dateSettings,
    docSettings,
    audioSettings,
    DeviceSelectDialog
  },
  watch: {
    activeTab(newIndex) {
      this.onTabChange(newIndex )
    },
  },
}
</script>

<style scoped lang="scss">


.createProrram {
  height: 100%;
  .van-button--small {
    min-width: 10px !important;
  }

  .top {
    padding: 15px 3px;
    display: flex;
    justify-content: space-between;
    .van-icon{
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .canvas {
    background-color: #131212;
    width: 100%;
    //height: 200px;
    display: flex;
    justify-content: center;
    align-items: center; /* 垂直居中 */
    box-sizing: border-box;
  }
  .control-wrapper {
    position: absolute;
    width: 100%;
    background: #ffffff;
    overflow-x: hidden; /* 隐藏水平滚动条 */
    white-space: nowrap; /* 防止控件换行 */
    left: 0;
  }

  .container {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
  }

  .header {
    display: flex;
    width: 100%;
    height: 50px;
    position: relative;

  }

  .playMode-content{
    //font-size:  16px;
    padding:10px;
    height: calc(100% - 60px);
    overflow-y: auto;
    .list{
      margin-bottom: 20px;
      .photo {
        box-sizing: border-box;
        padding: 5px;

        .updata-centnt {
          width: 100%;
          height: 100%;
          border-radius: 5px;

          .updata {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            flex-direction: column;
            align-items: center;
            background: #ffffff;

            .updata-img {
              width: 40%;
              height: 40%;
              margin-bottom: 10px;
            }
          }
        }
      }
    }
    .cell-title {
      height: 30px;
      line-height: 30px;
    }
    .progremList {
      overflow-y: auto;
      background: #fff;
      .van-radio{
        overflow: initial;
      }
      .van-radio-group--horizontal{
        display: flex;
        flex-wrap: nowrap;
        flex-direction: row;
      }
    }
    .van-row {
      .van-col {
        display: flex;
        align-items: center;
        flex-direction: column;
        height: 40px;
      }
    }
    .weekliWrap {
      display: flex;
      margin: 10px 0;
      justify-content: space-around;
      position: relative;

      .coverWrap {
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        right: 0;
        z-index: 10;
      }

      .weekli {
        width: 40px;
        height: 40px;
        background: #fff;
        border: 1px solid #006EFF;
        color: #006EFF;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .weekli.active {
        background: #006EFF;
        color: #fff;
      }
    }
  }
  .overlay {
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    .wrapper {
      padding: 0 16px;
      border-radius: 10px;
      display: flex;
      flex-wrap: wrap;
      justify-content: left;
      gap: 10px;
      max-width: 100%;
      max-height: 50%;
    }

    .icon-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: calc(25% - 10px); /* 25% width minus gap to fit 4 items in a row */
      box-sizing: border-box;
      text-align: center;
    }
    .overlay-text{
      max-width: 79px;
      white-space: nowrap; /* 确保文本在一行显示 */
      overflow: hidden; /* 超出容器部分隐藏 */
      text-overflow: ellipsis; /* 使用省略号表示文本被截断 */
    }
    .van-icon {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }

    span {
      margin-top: 10px;
      display: inline-block;
      white-space: nowrap; /* Prevent text from wrapping */
      color: #FFFFFF;
    }
  }

  .tabs-container {
    flex: 1;
    overflow-x: auto;

  }
  .custom-van-tabs{
    height: 100%;
    .delete-icon {
      position: absolute; /* 绝对定位 */
      top: 2px; /* 调整到标签的右上角 */
      right: 2px; /* 调整到标签的右上角 */
      cursor: pointer;
      img{
        width: 20px;
        height: 20px;
      }
      .van-tab{
        font-size:  16px !important;
      }
    }
  }
  .tabs-btn {
    width: auto;
    display: flex;
    height: 100%;
    justify-content: flex-end;
    align-items: center;
    .van-button--default{
      border-left: 2px solid rgba(193, 193, 193, 0.45);
      width: 70px;
      background-color: rgba(215, 215, 215, 0.45) !important;
      height: 100%;
      border-radius: 0px !important;
    }

  }

  #image {
    background: #ffffff;
    position: relative;
    width: 100%;
  }

  .resizable-content {
    overflow: hidden;
    width: 100%;
    height: 100%;

    .img-content {
      width: 100%;
      height: 100%;
    }

    .text-content {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }

  }


}
</style>
